module.exports = __webpack_public_path__ + "static/media/gooseCampaign.6e22cf4c.png";